import request from '@/utils/request.js'

/** 码表 */
export function searchCodeList () {
  return request({
    url: '/oil/item',
    method: 'get',
    params: {
      menu: 'GasTankConfig'
    }
  })
}


export function searchCodeListConfig (store_id) {
  return request({
    url: '/oil/item',
    method: 'get',
    params: {
      menu: 'GasTankConfig',
      store_id: store_id
    }
  })
}
